// removed by extract-text-webpack-plugin
module.exports = {"sideMenu":"sideMenu__1Fxf1","sideMenu_list":"sideMenu_list__328NY","sideMenu_list_item":"sideMenu_list_item__2-91x","sideMenu_list_item__selected":"sideMenu_list_item__selected__3GptS","sideMenu__productMenu":"sideMenu__productMenu__RPKaq","sideMenu__navigationMenu":"sideMenu__navigationMenu__2Yec9","sideMenu_mobileMenu":"sideMenu_mobileMenu__1AtgO","navigation_inner":"navigation_inner__2vx-U","transitionMenuOut":"transitionMenuOut__NifpM"};


//////////////////
// WEBPACK FOOTER
// ./components/SideMenu/SideMenu.scss
// module id = T/l/
// module chunks = 0